export default "__VITE_ASSET__TdHwnTNQ__"